import { Icon, Text } from "@fluentui/react";
import { useContext,  useState } from "react";
import { TableStateManager } from "../../Services/TableStateManager";
import { useTheme } from "../../Themes/themeContext";
import { buttonRootStyles } from "../Overview/Table/Header/Header";
import { TableContext } from "../Overview/Table/Table";
import { useTranslation } from "../../Locales/i18n/localizationService";

export const RenderHideGenericResourceToggle: React.FC<{item: any, dismissMenu: any}> = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	const ctx = useContext(TableContext) as TableStateManager & { ToggleHideGenericResources: () => void };

	const [hideGenericResources, setHideGenericResources] = useState<boolean>(() => ctx.Get(_ => _.GridSettingsHideGenericResources));

	return (
		<Text 
			onClick={() => {
				ctx.Get(_ => _.SetGridSettingsHideGenericResourcesCallback)(!hideGenericResources);
				ctx.ToggleHideGenericResources();

				setHideGenericResources(s => !s);
			}}
			styles={{ 
				root: {
					...buttonRootStyles, 
					"&:hover": {
						backgroundColor: theme.semanticColors.buttonBackgroundHovered,
					},
				}
			}}
		>
			<Icon 
				iconName="ContactInfo" 
				styles={{ root: {
					paddingTop: 2,
					marginRight: 8,
					marginLeft: 4,
					color: theme.semanticColors.menuIcon,
					fontSize: 16,
				}}} 
			/>
			{ hideGenericResources ? t("GridSettings.ShowGenericResources") : t("GridSettings.HideGenericresources") }
		</Text>
	)	
};